import angular from 'angular';

var module = angular.module('app.change-password', []);

export default module;